import { Component, input, ChangeDetectionStrategy } from '@angular/core';
import { LabelValue } from '@app/shared/forms/label-value/label-value';
import { EmployeeFormValue } from '../../embauche-tabs-form/employee-form/employee-form';

@Component({
  standalone: true,
  selector: 'app-employee-view',
  imports: [LabelValue],
  templateUrl: './employee-view.html',
  changeDetection: ChangeDetectionStrategy.Eager,
  styleUrls: ['./employee-view.scss'],
})
export class EmployeeView {
  contact = input.required<EmployeeFormValue>();
}
